import { render } from "./GuestDocumentsPanel.vue?vue&type=template&id=38f1be64"
import script from "./GuestDocumentsPanel.vue?vue&type=script&lang=js"
export * from "./GuestDocumentsPanel.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"
import "@/css/GuestDocumentsPanel.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__